import styled from 'styled-components'
import { Checkbox } from '@velasca/ui/checkbox'
import { InfoButton } from '@velasca/ui/info-button'

export const Wrapper = styled.div`
  display: flex;
  gap: 0.8rem;
  align-items: baseline;
`

export const StyledCheckbox = styled(Checkbox)`
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;

  button {
    border-color: ${({ theme }) => theme.colors.text.primary};
  }
`

export const StyledInfoButton = styled(InfoButton)`
  z-index: 1050;
`
